import { put, takeEvery } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { createNewHighlight } from "./helpers/createItems";
import { push } from "connected-react-router";


function* addItem({payload}) {
    yield createNewHighlight(payload.itemData)

    if(payload.closePagePath)  {
        yield put(push(payload.closePagePath))
    }
}


export function* watchAddHighlight() {
    try {
        yield takeEvery(actionTypes.HIGHLIGHTS_REQUEST_ADD_ITEM, addItem)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}